import { useState } from 'react';

interface ShareDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

export default function ShareDialog({ open, onClose, title }: ShareDialogProps) {
  const [copied, setCopied] = useState(false);

  if (!open) return null;

  const shareUrl = typeof window !== 'undefined' ? window.location.href : '';

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  };

  const channels = [
    { key: 'wechat', label: '微信', icon: 'ri-wechat-line' },
    { key: 'weibo', label: '微博', icon: 'ri-weibo-line' },
    { key: 'qq', label: 'QQ', icon: 'ri-qq-line' },
    { key: 'link', label: copied ? '已复制' : '复制链接', icon: copied ? 'ri-check-line' : 'ri-link' },
  ];

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-primary-950/50" onClick={onClose} role="presentation"></div>
      <div className="relative w-full max-w-sm rounded-lg bg-background-50 border border-background-200 p-6 animate-fade-up">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-semibold text-foreground-950">分享内容</h3>
            <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{title}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center text-foreground-700 shrink-0"
          >
            <i className="ri-close-line"></i>
          </button>
        </div>
        <div className="mt-5 grid grid-cols-4 gap-3">
          {channels.map((channel) => (
            <button
              key={channel.key}
              type="button"
              onClick={channel.key === 'link' ? handleCopy : undefined}
              className="flex flex-col items-center gap-2 group"
            >
              <span className="w-12 h-12 rounded-full bg-background-100 border border-background-200 flex items-center justify-center text-foreground-700 group-hover:bg-primary-500 group-hover:text-background-50 group-hover:border-primary-500 transition-colors">
                <i className={`${channel.icon} text-xl`}></i>
              </span>
              <span className="text-[11px] text-foreground-600">{channel.label}</span>
            </button>
          ))}
        </div>
        <p className="mt-5 text-[11px] text-foreground-400 leading-relaxed">
          分享功能为前端演示，点击「复制链接」可将当前页面地址复制到剪贴板。
        </p>
      </div>
    </div>
  );
}